import '../Styles/NotFound.css';
function WebTeam() {
return(
    <div className="notfound">
        <div className="notfoundcard">
            <div className="code">ERROR 404</div>
        </div>
    </div>
);
}

export default WebTeam;